import { toAmPm } from "../helper/helper";
import { BASE_URL } from "./providerApi";

export const createEmpanelment = async (storeData, accessToken) => {
    const {
        providerData,
        formData,
        authorityData,
        selectedServices,
        selectedSpecialities,
    } = storeData;


    const params = new URLSearchParams();

    params.append('providerType_ID', providerData.providerType);
    params.append('ProviderName', providerData.facilityName);
    params.append('IsThisBranch', providerData.isBranch);
    params.append('MainBranchName', providerData.mainBranchHANumber || '');

    params.append('HealthAuthority_ID', providerData.healthAuthority);
    params.append('Provider_Address_Country_ID', 160);
    params.append('Provider_Address_State_ID', providerData.emirates || 0);
    params.append('Provider_Address_City_ID', providerData.city || 0);
    params.append('Provider_Address_CityArea_ID', providerData.area || 0);
    params.append('Provider_Address_Street', providerData.street);
    params.append('Provider_Location', providerData.location);
    params.append('POBox', providerData.poBox || '');
    params.append('LandlineNo', providerData.landline || '');
    params.append('Provider_Address_Website', providerData.website || '');

    // Facility / Trade licenses
    params.append('Provider_HA_RegNo', authorityData.facilityLicenseNo || '');
    params.append('Provider_HA_RegNoValidToDate', authorityData.facilityLicenseExpiry || '');
    params.append('Provider_Trade_LicNo', authorityData.tradeLicNo || '');
    params.append('Provider_Trade_LicName', authorityData.tradeLicName || '');
    params.append('Provider_Trade_LivNoValidToDate', authorityData.tradeLicExpiry || '');

    // Signatory
    params.append('Signatory_Name', authorityData.signatory1Name || '');
    params.append('Signatory_Designation', authorityData.signatory1Designation || '');
    params.append('Signatory_EmiratesID', authorityData.signatory1EmiratesId || '');
    params.append('Signatory_ContactNo', authorityData.signatory1ContactNo || '');
    params.append('Signatory_Remarks', authorityData.signatory1Remarks || '');

    // Business hours
    params.append(
        'BusinessHr_Sunday_Thursday_Morning_Open',
        toAmPm(providerData.openTime)
    );
    params.append(
        'BusinessHr_Sunday_Thursday_Morning_Close',
        toAmPm(providerData.closeTime)
    );

    // Department contacts
    params.append('ContactDtl_NetAndInsDep_Name', authorityData.networkInsuranceName1 || '');
    params.append('ContactDtl_NetAndInsDep_eMail', authorityData.networkInsuranceEmail1 || '');
    params.append('ContactDtl_NetAndInsDep_ContactNo', authorityData.networkInsuranceContact1 || '');

    params.append('ContactDtl_AdminDep_Name', authorityData.administrationName1 || '');
    params.append('ContactDtl_AdminDep_eMail', authorityData.administrationEmail1 || '');
    params.append('ContactDtl_AdminDep_ContactNo', authorityData.administrationContact1 || '');

    params.append('ContactDtl_AccountsDep_Name', authorityData.accountsName1 || '');
    params.append('ContactDtl_AccountsDep_eMail', authorityData.accountsEmail1 || '');
    params.append('ContactDtl_AccountsDep_ContactNo', authorityData.accountsContact1 || '');

    // Patient capacity & discount
    params.append('Facility_PatientCapacity_OP', formData.patientCapacityOP || 0);
    params.append('Facility_PatientCapacity_IP', formData.patientCapacityIP || 0);
    params.append('Facility_PatientCapacity_DC', formData.patientCapacityDC || 0);
    params.append('RequestDiscount', formData.discount || 0);

    // Multiple Facility IDs & Specialities
    selectedServices.forEach((id) => params.append('FacilityIDs', id));
    selectedSpecialities.forEach((id) => params.append('SpecialityIDs', id));

    params.append('facilityremarks', formData.facilityRemarks || '');

    // -----------------------------
    // Build FormData for files
    // -----------------------------
    const fd = new FormData();

    if (formData.tradeLicenseFile) fd.append('TradeLicense', formData.tradeLicenseFile);
    if (formData.tariffListFile) fd.append('TariffList', formData.tariffListFile);
    if (formData.haLicenseFile) fd.append('HALicense', formData.haLicenseFile);
    if (formData.signatoryEmiratesIdFile) fd.append('SignatoryEmiratesID', formData.signatoryEmiratesIdFile);
    if (formData.otherFiles) fd.append('Others', formData.otherFiles);

    // -----------------------------
    // API Call with Bearer Token
    // -----------------------------
    const response = await fetch(
        `${BASE_URL}/providerempanelment/CreateEmpanelment?${params.toString()}`,
        {
            method: 'POST',
            headers: {
                accept: '*/*',
                Authorization: `Bearer ${accessToken}`,
            },
            body: fd,
        }
    );

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to submit empanelment');
    }
    const result = await response.json();
    return result;
};





export const updateEmpanelment = async (storeData, accessToken, empanelmentPkID, empanelmentRefNo) => {
    const {
        providerData,
        formData,
        authorityData,
        selectedServices,
        selectedSpecialities,
    } = storeData;

    const params = new URLSearchParams();

    // Add the new required parameters for update
    params.append('empanelment_PkID', empanelmentPkID);
    params.append('empanelment_RefNo', empanelmentRefNo);

    params.append('providerType_ID', providerData.providerType);
    params.append('ProviderName', providerData.facilityName);
    params.append('IsThisBranch', providerData.isBranch);
    params.append('MainBranchName', providerData.mainBranchHANumber || '');

    params.append('HealthAuthority_ID', providerData.healthAuthority);
    params.append('Provider_Address_Country_ID', 160);
    params.append('Provider_Address_State_ID', providerData.emirates || 0);
    params.append('Provider_Address_City_ID', providerData.city || 0);
    params.append('Provider_Address_CityArea_ID', providerData.area || 0);
    params.append('Provider_Address_Street', providerData.street);
    params.append('Provider_Location', providerData.location);
    params.append('POBox', providerData.poBox || '');
    params.append('LandlineNo', providerData.landline || '');
    params.append('Provider_Address_Website', providerData.website || '');

    // Facility / Trade licenses
    params.append('Provider_HA_RegNo', authorityData.facilityLicenseNo || '');
    params.append('Provider_HA_RegNoValidToDate', authorityData.facilityLicenseExpiry || '');
    params.append('Provider_Trade_LicNo', authorityData.tradeLicNo || '');
    params.append('Provider_Trade_LicName', authorityData.tradeLicName || '');
    params.append('Provider_Trade_LivNoValidToDate', authorityData.tradeLicExpiry || '');

    // Signatory
    params.append('Signatory_Name', authorityData.signatory1Name || '');
    params.append('Signatory_Designation', authorityData.signatory1Designation || '');
    params.append('Signatory_EmiratesID', authorityData.signatory1EmiratesId || '');
    params.append('Signatory_ContactNo', authorityData.signatory1ContactNo || '');
    params.append('Signatory_Remarks', authorityData.signatory1Remarks || '');

    // Business hours
    params.append(
        'BusinessHr_Sunday_Thursday_Morning_Open',
        toAmPm(providerData.openTime)
    );
    params.append(
        'BusinessHr_Sunday_Thursday_Morning_Close',
        toAmPm(providerData.closeTime)
    );

    // Department contacts
    params.append('ContactDtl_NetAndInsDep_Name', authorityData.networkInsuranceName1 || '');
    params.append('ContactDtl_NetAndInsDep_eMail', authorityData.networkInsuranceEmail1 || '');
    params.append('ContactDtl_NetAndInsDep_ContactNo', authorityData.networkInsuranceContact1 || '');

    params.append('ContactDtl_AdminDep_Name', authorityData.administrationName1 || '');
    params.append('ContactDtl_AdminDep_eMail', authorityData.administrationEmail1 || '');
    params.append('ContactDtl_AdminDep_ContactNo', authorityData.administrationContact1 || '');

    params.append('ContactDtl_AccountsDep_Name', authorityData.accountsName1 || '');
    params.append('ContactDtl_AccountsDep_eMail', authorityData.accountsEmail1 || '');
    params.append('ContactDtl_AccountsDep_ContactNo', authorityData.accountsContact1 || '');

    // Patient capacity & discount
    params.append('Facility_PatientCapacity_OP', formData.patientCapacityOP || 0);
    params.append('Facility_PatientCapacity_IP', formData.patientCapacityIP || 0);
    params.append('Facility_PatientCapacity_DC', formData.patientCapacityDC || 0);
    params.append('RequestDiscount', formData.discount || 0);

    // Multiple Facility IDs & Specialities
    selectedServices.forEach((id) => params.append('FacilityIDs', id));
    selectedSpecialities.forEach((id) => params.append('SpecialityIDs', id));

    params.append('facilityremarks', formData.facilityRemarks || '');

    // -----------------------------
    // Build FormData for files
    // Only include files that are File objects (newly uploaded)
    // If they're strings (existing filenames), don't include them
    // -----------------------------
    const fd = new FormData();

    if (formData.tradeLicenseFile instanceof File) {
        fd.append('TradeLicense', formData.tradeLicenseFile);
    }
    if (formData.tariffListFile instanceof File) {
        fd.append('TariffList', formData.tariffListFile);
    }
    if (formData.haLicenseFile instanceof File) {
        fd.append('HALicense', formData.haLicenseFile);
    }
    if (formData.signatoryEmiratesIdFile instanceof File) {
        fd.append('SignatoryEmiratesID', formData.signatoryEmiratesIdFile);
    }
    if (formData.otherFiles instanceof File) {
        fd.append('Others', formData.otherFiles);
    }

    // -----------------------------
    // API Call with Bearer Token
    // -----------------------------
    const response = await fetch(
        `${BASE_URL}/providerempanelment/UpdateEmpanelment?${params.toString()}`,
        {
            method: 'PUT',
            headers: {
                accept: '*/*',
                Authorization: `Bearer ${accessToken}`,
            },
            body: fd,
        }
    );

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to update empanelment');
    }
    const result = await response.json();
    return result;
};
